/** Deterministic initials (max 2, uppercase) for an avatar fallback. Empty words are skipped. */
export const getInitials = (name: string | null | undefined): string =>
	(name ?? "")
		.split(" ")
		.filter(Boolean)
		.map((word) => word[0])
		.slice(0, 2)
		.join("")
		.toUpperCase();
